import { useNavigate } from "react-router-dom";
import { FaShareAlt, FaMoneyBillWave, FaFlag, FaBriefcase, FaUser, FaEnvelope } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { setDataAssistant } from "../../context/assistantSlice";
import { useEffect, useState } from "react";
import { GET_DATA } from "../../services/API";

import { v4 as uuidv4 } from 'uuid';
import { transformDatePtBR } from "../../utils";

export default function DashboardCards() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const authentication = useSelector((state) => state.authentication);

    const [assistats, setAssistants] = useState([]);

    useEffect(() => {
        (async () => {
            const result = await GET_DATA('Assistant/GetAllAssistantBasicData?flgActive=true');

            setAssistants(result.data);
        })();
    }, []);

    const data = [
        {
            title: "Agendamento", value: "59", color: "text-blue-500", bg: "bg-blue-50", icon: <FaShareAlt size={32} className="text-blue-500" />, onClick: () => {
                const assistant = assistats.filter(a => a.id === 1)[0];

                dispatch(setDataAssistant({ name: assistant?.name, assistantId: assistant?.assistantId, externalReference: uuidv4(), messages: [{ sender: "assistant", text: "Bem-vindo! Como posso te ajudar?", time: transformDatePtBR(new Date()) }] }));
                navigate('/conversation-chat', { state: { id: assistant.id } });
            }
        },
        {
            title: "Performance", value: "96", color: "text-blue-500", bg: "bg-blue-50", icon: <FaShareAlt size={32} className="text-blue-500" />, onClick: () => {
                const assistant = assistats.filter(a => a.id === 2)[0];

                dispatch(setDataAssistant({ name: assistant?.name, assistantId: assistant?.assistantId, externalReference: uuidv4(), messages: [{ sender: "assistant", text: "Bem-vindo! Como posso te ajudar?", time: transformDatePtBR(new Date()) }] }));
                navigate('/conversation-chat', { state: { id: assistant.id, agente: 'Hermes' } });
            }
        },

        { title: "Enfermagem", value: "$96k", color: "text-green-500", bg: "bg-green-50", icon: <FaShareAlt size={32} className="text-blue-500" /> },
        { title: "Vendas", value: "696", color: "text-red-500", bg: "bg-red-50", icon: <FaShareAlt size={32} className="text-blue-500" /> },
        { title: "Juridico", value: "356", color: "text-blue-500", bg: "bg-blue-50", icon: <FaShareAlt size={32} className="text-blue-500" /> },
        { title: "Reabilitação", value: "3,650", color: "text-orange-500", bg: "bg-orange-50", icon: <FaShareAlt size={32} className="text-blue-500" />, onClick: () => {
            const assistant = assistats.filter(a => a.id === 2)[0];

            dispatch(setDataAssistant({ name: assistant?.name, assistantId: assistant?.assistantId, externalReference: uuidv4(), messages: [{ sender: "assistant", text: "Bem-vindo! Como posso te ajudar?", time: transformDatePtBR(new Date()) }] }));
            navigate('/conversation-chat', { state: { id: assistant.id, agente: 'Aquiles' } });
        } },
        { title: "Nutrição", value: "96", color: "text-blue-500", bg: "bg-blue-50", icon: <FaShareAlt size={32} className="text-blue-500" />, onClick: () => {
            const assistant = assistats.filter(a => a.id === 2)[0];

            dispatch(setDataAssistant({ name: assistant?.name, assistantId: assistant?.assistantId, externalReference: uuidv4(), messages: [{ sender: "assistant", text: "Bem-vindo! Como posso te ajudar?", time: transformDatePtBR(new Date()) }] }));
            navigate('/conversation-chat', { state: { id: assistant.id, agente: 'Atlanta' } });
        } },
    ];

    return (
        <div className="flex flex-wrap justify-center gap-5 ">
            
            {data.map((item, index) => {
                const element = <div key={index} className={`p-4 rounded-lg shadow-md w-60 h-42 flex flex-col items-center justify-center ${item.bg} dark:bg-gray-600 cursor-pointer`} onClick={() => {
                    if (item.onClick) {
                        item.onClick();
                    }
                }}>
                    {item.icon}
                    <span className="text-[16px] font-semibold dark:text-white text-center break-words w-[110px] mt-[18px]">{item.title}</span>
                    {/* <span className={`text-lg font-bold ${item.color}`}>{item.value}</span> */}
                </div>

                if (authentication?.user?.login === "fCamilo" && (item.title.includes("Reabilitação") || item.title.includes("Nutrição") || item.title.includes("Performance"))) {
                    return element;
                }
                else if(authentication?.user?.login === "admin"){
                    return element;
                }

                return 
            })}
        </div>
    );
}